import React from "react";
import { useNavigate } from "react-router-dom";

export default function BackButton({ to, label = "Back", className = "" }) {
  const navigate = useNavigate();

  const onClick = () => {
    if (to) return navigate(to);
    if (window.history.length > 1) return navigate(-1);

    const roleId = parseInt(localStorage.getItem("role_id"), 10);
    const fallback =
      roleId === 2 || roleId === 3 || roleId === 4
        ? "/proposal/view-submissions"
        : "/dashboard";
    navigate(fallback);
  };

  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      className={`btn ghost back-btn ${className}`}
      onClick={onClick}
    >
      <svg
        className="back-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24" width="16" height="16" fill="currentColor"
      >
        <path d="M15.5 19a1 1 0 0 1-.7-.29l-6-6a1 1 0 0 1 0-1.42l6-6a1 1 0 1 1 1.4 1.42L10.91 12l5.3 5.29A1 1 0 0 1 15.5 19z"/>
      </svg>
      <span className="back-label">{label}</span>
    </button>
  );
}
